import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CustomTick from './CustomTick'; // Import the custom tick component

function FuelLevelTimeSeries() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get('http://vicenterc-001-site35.etempurl.com/API/D_TimeSeries.php');
      const formattedData = response.data.map(entry => ({
        daterecord: new Date(entry.daterecord).toLocaleString(),
        fuellevel: parseFloat(entry.fuellevel),
      }));
      setData(formattedData);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h2><center>Fuel Level Time Series</center></h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="chart-container">
          <ResponsiveContainer width="100%" height={400}>
            <LineChart
              data={data}
              margin={{
                top: 5, right: 30, left: 20, bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="daterecord" tick={<CustomTick />} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="fuellevel" stroke="#8884d8" activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default FuelLevelTimeSeries;
